var Backbone = require('backbone');

var Base = require('front/components/Base/Base');

require('owl.carousel');
require('owl.carousel/dist/assets/owl.carousel.css');

require('./IndexSlider.less');

module.exports = Base.extend({
    template: require('./IndexSlider.jinja'),

    el: '.IndexSlider',

    events: {
        'click .IndexSlider-navItem': 'onNavClick',
        'click .IndexSlider-slide--side': 'onSlideClick',
        'click .IndexSlider-mainNav-item': 'onClickItemNav'
    },

    initialize: function (options) {
        if (app.settings.isMobile) {
            this.$('.IndexSlider-mainSlider').owlCarousel({
                items: 1,
                autoWidth: true,
                loop: true
            });

            return;
        }

        var $arrowSvg = this.$('.IndexSlider-arrow svg');
        var fontSize = $('html').css('font-size')
            .slice(0, -2);
        // Get responsive height in rem
        var sideHeight = Math.round(this.$('.IndexSlider-side').height() / fontSize * 100) / 100;

        this.$sliderMain = this.$('.IndexSlider-mainSlider');
        this.$sliderSide = this.$('.IndexSlider-sideSlider');

        this.$sliderPrev = this.$('.IndexSlider-navItem--prev');
        this.$sliderNext = this.$('.IndexSlider-navItem--next');

        this.currentSlide = 0;

        this.slideNumber = 2;
        this.firstVisibleItemNumber = 0;
        this.visibleSlidesNumber = 3;
        this.sliderItemsNumber = this.$('.IndexSlider-slide--side').length;
        this.sliderSideTransform = 0;
        // Get responsive height in rem
        this.slideHeight = Math.round(this.$('.IndexSlider-slide--side').outerHeight() / fontSize * 1000) / 1000;
        this.sliderSideMinTransform = sideHeight - this.slideHeight * this.sliderItemsNumber;

        this.mainSlideHeight = Math.round(this.$('.IndexSlider-slide--main').outerHeight() / fontSize * 1000) / 1000;

        $(window).on('resize', this.onResize.bind(this));
    },

    onResize: function (e) {
        clearTimeout(this.idSliderTranslate);

        this.$sliderMain.css('translate', 'none');

        this.idSliderTranslate = setTimeout(function () {
            this.$sliderMain.css('translate', '.5s transform ease-out');
        }.bind(this), 60);
    },

    viewsRegistration: function () {
    },

    onNavClick: function (e) {
        var $target = $(e.target);
        var currentSlideNumber;

        if (!$target.hasClass('IndexSlider-navItem')) $target = $target.closest('.IndexSlider-navItem');

        if ($target.hasClass('IndexSlider-navItem--prev')) {
            currentSlideNumber = Math.min(this.slideNumber, this.firstVisibleItemNumber);
            this.sliderSideTransform += currentSlideNumber * this.slideHeight;
            this.sliderSideTransform = Math.min(this.sliderSideTransform, 0);
            this.firstVisibleItemNumber -= currentSlideNumber;
        } else {
            currentSlideNumber = Math.min(this.slideNumber, this.sliderItemsNumber - this.firstVisibleItemNumber - this.visibleSlidesNumber);
            this.sliderSideTransform -= currentSlideNumber * this.slideHeight;
            this.sliderSideTransform = Math.max(this.sliderSideTransform, this.sliderSideMinTransform);
            this.firstVisibleItemNumber += currentSlideNumber;
        }

        this.$sliderSide.css('transform', 'translateY(' + this.sliderSideTransform + 'rem)');

        this.$sliderPrev.toggleClass('IndexSlider-navItem--isDisabled', this.firstVisibleItemNumber == 0);
        this.$sliderNext.toggleClass('IndexSlider-navItem--isDisabled', this.firstVisibleItemNumber + this.visibleSlidesNumber == this.sliderItemsNumber);
    },

    onSlideClick: function (e) {
        var $slide = $(e.currentTarget);
        var id = Number($slide.data('id'));

        if ($slide.hasClass('IndexSlider-slide--isActive')) return;

        this.$('.IndexSlider-slide--side').removeClass('IndexSlider-slide--isActive');
        $slide.addClass('IndexSlider-slide--isActive');
        this.currentSlide = id;
        this.onChangeSlide(id);
    },

    onClickItemNav: function (e) {
        var $item = $(e.currentTarget);

        var ind = 0;
        if ($item.hasClass('IndexSlider-mainNav-item--bottom')) { // if next
            this.currentSlide++;
        } else { // if prev
            this.currentSlide--;
        }

        this.currentSlide = (this.currentSlide < 0) ? 0 : ((this.currentSlide > this.sliderItemsNumber - 1) ? (this.sliderItemsNumber - 1) : this.currentSlide);

        this.onChangeSlide(this.currentSlide);

        this.$('.IndexSlider-slide--side').removeClass('IndexSlider-slide--isActive');
        this.$('.IndexSlider-slide--side[data-id=' + this.currentSlide + ']').addClass('IndexSlider-slide--isActive');
    },

    onChangeSlide: function (id) {
        var offset = id * this.mainSlideHeight;
        this.$sliderMain.css('transform', 'translate3d(0,' + (-offset) + 'rem,0)');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSlider/IndexSlider.js
// module id = 54
// module chunks = 0